import React, { useState, useEffect } from 'react';
import { getAtcDetail } from '../../../../../client/atc';
import { MODALS } from '../../../../../config/images';
const DetailATC = ({ isOpen, onClose, atcData }) => {

  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDetails = async () => {
      if (isOpen && atcData?.id) {
        setLoading(true);
        setError(null);
        setDetails(null);
        
        try {
          const response = await getAtcDetail(atcData.id);
          setDetails(response);
        } catch (error) {
          console.error('Error fetching ATC details:', error);
          setError('No se pudieron cargar los detalles del ATC');
        } finally {
          setLoading(false);
        }
      }
    };

    fetchDetails();
  }, [isOpen, atcData]);

  const formatDate = (dateString) => {
    if (!dateString) return 'No disponible';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch (error) {
      return 'Fecha inválida';
    }
  };

  const formatHours = (hours) => {
    if (hours === null || hours === undefined) return '-';
    return hours.toString();
  };

  const formatBoolean = (value) => {
    if (value === null || value === undefined) return '-';
    return value ? 'Sí' : 'No';
  };

  //data prueba

    const tableData = [
    { id: 1, descripcion: 'Mantenimiento preventivo motor principal', monto: '1,250.00', moneda: 'USD' },
    { id: 2, descripcion: 'Cambio de filtros y lubricantes', monto: '850.50', moneda: 'USD' },
    { id: 3, descripcion: 'Reparación sistema de refrigeración', monto: '2,100.75', moneda: 'USD' }
  ];
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[90%] max-h-[85%] lg:w-[943px] p-4 overflow-hidden flex flex-col bg-white rounded-[29px]">
        <div className="flex justify-end w-full ">
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <img src={MODALS.CLOSE} alt="cerrar"/>
            </button>
        </div>

        <div className='flex flex-col flex-1 gap-4 px-2 pb-3 overflow-y-auto'>
            <h1 className="text-blue font-itcbold text-2xl md:text-[32px]">
                Aprobar / Rechazar códigos de servicio
            </h1>
          {loading ? (
            <div className="flex items-center justify-center py-8">
              <p className="text-blue font-itcmedium">Cargando detalles...</p>
            </div>
          ) : error ? (
            <div className="flex items-center justify-center py-8">
              <p className="text-red font-itcmedium">{error}</p>
            </div>
          ) : details ? (
            <>
            <div className='grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3'>
                <div className='flex flex-col gap-1'>
                    <p className='text-lg text-blue font-itcmedium'>
                        Técnico responsable proveedor
                    </p>
                    <p className='border w-full md:w-[277px] text-sm font-itcbook text-[#6B7280] border-[#6B7280] flex p-2  items-center rounded-md'>
                        {details.proveedor_tecnico_responsable}
                    </p>
                </div>
                <div className='flex flex-col gap-1'>
                    <p className='text-lg text-blue font-itcmedium'>
                        Fecha de llenado de ATC
                    </p>
                    <p className='border w-full md:w-[277px] text-sm font-itcbook text-[#6B7280] border-[#6B7280] flex p-2  items-center rounded-md'>
                        {formatDate(details.atc_fecha_llenado)}
                    </p>
                </div>
            </div>
            <div className='flex flex-col gap-1'>
                <p className='text-lg text-blue font-itcmedium'>
                    Descripción del trabajo efectuado
                </p>
                <p className='border w-full text-sm font-itcbook text-[#6B7280] border-[#6B7280] flex p-2 rounded-md'>
                    {details.resumen_total }
                </p>
            </div>
            <div className='grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3'>
                <div className='flex flex-col gap-1'>
                    <p className='text-lg text-blue font-itcmedium'>
                        Fecha Inicio de Trabajo
                    </p>
                    <p className='border w-full md:w-[277px] text-sm font-itcbook text-[#6B7280] border-[#6B7280] flex p-2 h-[40px] items-center rounded-md'>
                        {formatDate(details.fecha_inicio_trabajo)}
                    </p>
                </div>
                <div className='flex flex-col gap-1'>
                    <p className='text-lg text-blue font-itcmedium'>
                        Fecha Fin de Trabajo
                    </p>
                    <p className='border w-full md:w-[277px] text-sm font-itcbook text-[#6B7280] border-[#6B7280] flex p-2 h-[40px] items-center rounded-md'>
                        {formatDate(details.fecha_fin_trabajo)}
                    </p>
                </div>
            </div>
            <div className='grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3'>
                <div className='flex flex-col gap-1'>
                    <p className='text-lg text-blue font-itcmedium'>
                        N° Trabajadores totales
                    </p>
                    <p className='border w-full md:w-[277px] text-sm font-itcbook text-[#6B7280] border-[#6B7280] flex p-2 h-[40px] items-center rounded-md'>
                        {details.numero_trabajadores}
                    </p>
                </div>
                <div className='flex flex-col gap-1'>
                    <p className='text-lg text-blue font-itcmedium'>
                        Horas trabajadas totales
                    </p>
                    <p className='border w-full md:w-[277px] text-sm font-itcbook text-[#6B7280] border-[#6B7280] flex p-2 h-[40px] items-center rounded-md'>
                        {formatHours(details.atc_provehortrabdia)} horas
                    </p>
                </div>
                <div className='flex flex-col gap-1'>
                    <p className='text-lg text-blue font-itcmedium'>
                        Garantía
                    </p>
                    <p className='border w-full md:w-[277px] text-sm font-itcbook text-[#6B7280] border-[#6B7280] flex p-2 h-[40px] items-center rounded-md'>
                        {formatBoolean(details.atc_garantia)}
                    </p>
                </div>
            </div>
            <div className='grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3'>
                <div className='flex flex-col gap-1'>
                    <p className='text-lg text-blue font-itcmedium'>
                        Equipo principal
                    </p>
                    <p className='text-base font-itcmedium text-[#6B7280]'>
                        {details.equipo_principal}
                    </p>
                </div>
                <div className='flex flex-col gap-1'>
                    <p className='text-lg text-blue font-itcmedium'>
                        Lugar atención
                    </p>
                    <p className='text-base font-itcmedium text-[#6B7280]'>
                        {details.lugar_atencion}
                    </p>
                </div>
                <div className='flex flex-col gap-1'>
                    <p className='text-lg text-blue font-itcmedium'>
                        OT tarea
                    </p>
                    <p className='text-base font-itcmedium text-[#6B7280]'>
                        {details.ot_tarea}
                    </p>
                </div>
            </div>
            <div className='flex flex-col gap-1'>
                <p className='text-lg text-blue font-itcmedium'>
                    Resumen
                </p>
                <p className='text-base font-itcmedium text-[#6B7280]'>
                    {details.atc_resumen}
                </p>
            </div>
            </>
          ) : (
            <div className="flex items-center justify-center py-8">
              <p className="text-red font-itcmedium">No se encontraron detalles del ATC.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailATC;